import { defineStore } from 'pinia'

export const useGroupsAttrsStore = defineStore('groups-attrs', () => {

    const admin         = ['GROUP_ADMIN', 'SUPER_ADMIN']                // Администратор группы польз-й, суперадмин
    // const main       = ['EDIT_PRIVATE_CAR']                          // Редакт. данных произв-я, получения значений параметров авто
    const navi          = ['GEODATA']                                   // Навигационная информация
    const remote        = ['REMOTE_CONTROL']                            // Удаленное управление
    const diagnostic    = ['DIAGNOSTIC']                                // Диагностика
    const developer     = ['COMMAND', 'FIRMWARE', 'LOGS_CAR', 'PARAM']  // Режим разработчика

    return {

        admin,
        navi,
        remote,
        diagnostic,
        developer
    }
})